<template>
  <el-form :model="queryParams" label-width="85px" style="margin-top: 20px;">
    <el-row>
      <el-col :span="24">
        <el-row>
          <el-col :span="8">
            <el-form-item label="备货方式：">
              <span v-if="type">{{queryParams.stockupType}}</span>
              <el-select v-model="queryParams.stockupType" v-else>
                <el-option label="直发备货" value="直发备货"></el-option>
                <el-option label="入库备货" value="入库备货"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="预计发货时间：" label-width="120px">
              <el-date-picker
                v-model="queryParams.deliveryTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择发货日期"
                :picker-options="$store.state.Sell.time"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24" v-show="queryParams.stockupType === '入库备货'">
        <el-row>
          <el-col :span="8">
            <el-form-item label="备货仓库：">
              <el-select v-model="queryParams.storageId" @change="changeStorageBase">
                <el-option
                  v-for="(ele, index) in storageBaseList"
                  :key="index"
                  :label="ele.storageName"
                  :value="ele.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库地址：" label-width="120px">{{ queryParams.storageAddress }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">{{ queryParams.storagePhone }}</el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24" v-show="queryParams.stockupType === '直发备货'">
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货方式：">
              <el-select v-model="queryParams.sendType" @change="changeSendType">
                <el-option label="直接发货" value="直接发货"></el-option>
                <el-option label="代发" value="代发"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发货人：" label-width="120px">
              <el-select
                v-show="queryParams.sendType === '直接发货'"
                v-model="queryParams.sendPeople"
                @change="changeVoObj"
              >
                <el-option
                  v-for="(val, index) in VoList"
                  :key="index"
                  :label="val.name"
                  :value="val.name"
                ></el-option>
              </el-select>
              <el-input
                v-show="queryParams.sendType === '代发'"
                v-model.trim="queryParams.sendPeople"
                placeholder="请填写收货人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              <el-input
                @input.native="onInput"
                v-show="queryParams.sendType === '代发'"
                v-model.trim="queryParams.sendPhone"
                placeholder="请填写联系电话"
              ></el-input>
              <span v-show="queryParams.sendType === '直接发货'">{{ queryParams.sendPhone }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24" v-show="queryParams.stockupType === '直发备货'">
        <el-row>
          <el-col :span="8">
            <el-row :gutter="10">
              <el-col :span="14">
                <el-form-item label="收货人：">
                  <el-consignee
                    :InfoList="InfoList"
                    ref="consigneeRefs"
                    @changeName="changeName"
                    :params="consigneeParams"
                  ></el-consignee>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-button @click="onEditConsignee" type="primary">编辑</el-button>
                <el-button @click="onAddConsignee" plain type="primary">添加</el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：" label-width="120px">
              <el-select
                v-if="telList.crMobile && telList.crPhone"
                v-model="consigneeParams.crPhone"
              >
                <el-option :label="telList.crMobile" :value="telList.crMobile"></el-option>
                <el-option :label="telList.crPhone" :value="telList.crPhone"></el-option>
              </el-select>
              <div v-else>
                <el-input @input.native="onInput" v-model="consigneeParams.crPhone" disabled></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货地址：">
              <span>{{ consigneeParams.crProvince }} {{ consigneeParams.crAddress }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="备注：">
              <el-input type="textarea" :rows="2" v-model="queryParams.mark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-------------- 添加 编辑收货人 -------------->
    <edit-consignee-dialog @getCustomer="getCustomer" :id="id" ref="editConsigneeDialogRefs"></edit-consignee-dialog>
  </el-form>
</template>
<script>
import editConsigneeDialog from '../../dialog/editConsigneeDialog'
import Consignee from '@/components/Consignee/index'
export default {
  props: ['id', 'orderContractReceive', 'storageBaseList', 'VoList', 'type', 'InfoList'],
  components: {
    'edit-consignee-dialog': editConsigneeDialog,
    'el-consignee': Consignee
  },
  data() {
    return {
      queryParams: {
        sendType: '直接发货',
        deliveryTime: '', // 预计发货时间
        stockupType: '入库备货'
      }, // 传给父组件的备货信息
      isShowonAddres: false, // 是否显示变更地址
      telList: {}, // 下拉电话
      consigneeParams: {} // 收货人信息
    }
  },
  watch: {
    type: {
      handler(val) {
        this.queryParams.stockupType = val
      },
      deep: true
    },
    orderContractReceive: {
      handler(val) {
        if (val) {
          this.consigneeParams = val
        }
      },
      deep: true
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号-
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    // 改变发货状态
    changeSendType() {
      delete this.queryParams.sendPeople
      delete this.queryParams.sendPhone
    },
    //   发货人改变
    changeVoObj(val) {
      const tempObj = this.VoList.filter((ele) => ele.name === val)[0]
      this.queryParams.sendPhone = tempObj.crPhone ? tempObj.crPhone : tempObj.crMobile
    },
    // 备货仓库改变
    changeStorageBase(val) {
      const obj = this.storageBaseList.find((ele) => ele.id === val)
      this.queryParams.storageName = obj.storageName
      this.queryParams.storageAddress = obj.storageAddress
      this.queryParams.storagePhone = obj.storagePhone
    },
    // 添加收货人
    onAddConsignee() {
      this.$refs.editConsigneeDialogRefs.onInitial('添加收货人')
    },
    // 编辑收货人
    onEditConsignee() {
      if (this.consigneeParams.id && this.consigneeParams.crName) {
        this.$refs.editConsigneeDialogRefs.onInitial('修改收货人', this.consigneeParams)
      } else {
        this.$message.error('请选择需要编辑的收货人!')
      }
    },
    // 确认添加收货人信息刷新组件列表
    getCustomer(obj) {
      this.consigneeParams = obj
      this.$refs.consigneeRefs.onConsignee(this.id, obj.id)
    },
    // 获取选择的收货人
    changeName(item) {
      if (item.crProcode || item.crProvince) {
        const recParams = this.$analysisAddress(item.crProcode, item.crProvince)
        item.provinceReceiving = recParams.province
        item.cityReceiving = recParams.city
        item.districtReceiving = recParams.district
      }
      this.consigneeParams = item
      if (item.customerRecevieMobileVoList) {
        this.telList = item.customerRecevieMobileVoList[0] // 下拉电话
      }
      if (this.telList.crMobile && !this.telList.crPhone) {
        this.consigneeParams.crPhone = this.telList.crMobile
      }
      if (this.telList.crPhone) {
        this.$set(this.consigneeParams, 'crPhone', this.telList.crPhone)
      }
    }
  }
}
</script>
